module.exports = __webpack_public_path__ + "e6b4531fe8e234714ae9036cba7957b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/day_10.jpg
// module id = 1658
// module chunks = 5